export default "__VITE_ASSET__B5wPGWu5__"